import LegalPageLayout from "@/components/landing/LegalPageLayout";

const CookiePolicy = () => (
  <LegalPageLayout title="Cookie Policy" lastUpdated="January 15, 2026">
    <section>
      <h2>1. What Are Cookies</h2>
      <p>
        Cookies are small text files placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences, keeping you signed in, and understanding how you use our services.
      </p>
    </section>

    <section>
      <h2>2. Types of Cookies We Use</h2>

      <h3>Essential Cookies</h3>
      <p>
        These cookies are necessary for the website to function and cannot be disabled. They include session management, authentication tokens, and security cookies required for card operations.
      </p>

      <h3>Performance Cookies</h3>
      <p>
        These cookies help us understand how visitors interact with our website by collecting anonymous usage data. We use this information to improve our services and user experience.
      </p>

      <h3>Functional Cookies</h3>
      <p>
        These cookies remember your preferences such as language, region, and display settings to provide a more personalized experience.
      </p>

      <h3>Analytics Cookies</h3>
      <p>
        We use analytics cookies to measure and analyze website traffic, page views, and user behavior. This data is aggregated and anonymized.
      </p>
    </section>

    <section>
      <h2>3. Third-Party Cookies</h2>
      <p>Some cookies are placed by third-party services that appear on our pages:</p>
      <ul>
        <li><strong>Cloudflare:</strong> Security and performance optimization</li>
        <li><strong>Google Analytics:</strong> Website usage analytics</li>
        <li><strong>Intercom:</strong> Customer support chat functionality</li>
        <li><strong>Stripe:</strong> Payment processing security</li>
      </ul>
    </section>

    <section>
      <h2>4. Managing Cookies</h2>
      <p>
        You can control and manage cookies through your browser settings. Most browsers allow you to refuse or delete cookies. However, disabling essential cookies may prevent you from using certain features of our service, including card management and transaction processing.
      </p>
      <p>Common browser cookie settings:</p>
      <ul>
        <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies</li>
        <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies</li>
        <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data</li>
        <li><strong>Edge:</strong> Settings → Cookies and Site Permissions</li>
      </ul>
    </section>

    <section>
      <h2>5. Cookie Retention</h2>
      <p>
        Session cookies are deleted when you close your browser. Persistent cookies remain on your device for a set period (typically 30 days to 2 years) or until you manually delete them. Essential security cookies related to authentication expire after 24 hours of inactivity.
      </p>
    </section>

    <section>
      <h2>6. Updates to This Policy</h2>
      <p>
        We may update this Cookie Policy from time to time. Changes will be posted on this page with an updated revision date. Continued use of our website after changes constitutes acceptance of the updated policy.
      </p>
    </section>
  </LegalPageLayout>
);

export default CookiePolicy;
